// export interface AppUser {
//   sub: string;
//   name: string;
//   image?: string | null;
//   [key:string]: string | any;
// }
export interface Role {
  label: string;
  value: string;
}

export const roles: Role[] = [
  { label: 'Admin', value: 'admin' },
  { label: 'User', value: 'user' },
  { label: 'Developer', value: 'dev' },
];
